// The native-maps kit icons for the back office's MapLibre (web) maps: the kit's @2x PNGs as Vite
// assets, and `addKitIcons(map)` to register them (src/lib/mapIcons.js has the logic and its tests).
// The kit's own icons/index.ts `require()`s the PNGs for React Native; vite.config.ts points the
// kit's `./icons` import here instead, so `mapIconAssets` is these URLs in the back office.
import type { Map as MapLibreMap } from 'maplibre-gl';
import { KIT_PIXEL_RATIO, registerKitIcons } from '../lib/mapIcons.js';
import poiFood from '../../../../packages/ui/src/map/icons/poi-food@2x.png';
import poiCafe from '../../../../packages/ui/src/map/icons/poi-cafe@2x.png';
import poiShop from '../../../../packages/ui/src/map/icons/poi-shop@2x.png';
import poiGrocery from '../../../../packages/ui/src/map/icons/poi-grocery@2x.png';
import poiHealth from '../../../../packages/ui/src/map/icons/poi-health@2x.png';
import poiSchool from '../../../../packages/ui/src/map/icons/poi-school@2x.png';
import poiWorship from '../../../../packages/ui/src/map/icons/poi-worship@2x.png';
import poiTransit from '../../../../packages/ui/src/map/icons/poi-transit@2x.png';
import poiBank from '../../../../packages/ui/src/map/icons/poi-bank@2x.png';
import poiFuel from '../../../../packages/ui/src/map/icons/poi-fuel@2x.png';
import poiGov from '../../../../packages/ui/src/map/icons/poi-gov@2x.png';
import poiPark from '../../../../packages/ui/src/map/icons/poi-park@2x.png';
import poiLandmark from '../../../../packages/ui/src/map/icons/poi-landmark@2x.png';
import popcartFresh from '../../../../packages/ui/src/map/icons/popcart-fresh@2x.png';
import popcartGrill from '../../../../packages/ui/src/map/icons/popcart-grill@2x.png';
import popcartMart from '../../../../packages/ui/src/map/icons/popcart-mart@2x.png';
import popcartExpress from '../../../../packages/ui/src/map/icons/popcart-express@2x.png';
import oneway from '../../../../packages/ui/src/map/icons/oneway@2x.png';

/** Icon id → @2x PNG URL (the ids in KIT_ICON_IDS). */
export const KIT_ICON_URLS: Record<string, string> = {
  'poi-food': poiFood,
  'poi-cafe': poiCafe,
  'poi-shop': poiShop,
  'poi-grocery': poiGrocery,
  'poi-health': poiHealth,
  'poi-school': poiSchool,
  'poi-worship': poiWorship,
  'poi-transit': poiTransit,
  'poi-bank': poiBank,
  'poi-fuel': poiFuel,
  'poi-gov': poiGov,
  'poi-park': poiPark,
  'poi-landmark': poiLandmark,
  'popcart-fresh': popcartFresh,
  'popcart-grill': popcartGrill,
  'popcart-mart': popcartMart,
  'popcart-express': popcartExpress,
  oneway,
};

/** What the kit's native.ts reads as `mapIconAssets` in the back office (see vite.config.ts). */
export const mapIconAssets = KIT_ICON_URLS;

/**
 * Register the kit icons on a back-office map, right after `new Map(...)`: place icons, shop pins
 * and one-way arrows draw instead of MapLibre's missing-image warnings.
 */
export function addKitIcons(map: MapLibreMap) {
  return registerKitIcons(map as never, KIT_ICON_URLS, { pixelRatio: KIT_PIXEL_RATIO });
}
